import { openBlock as r, createElementBlock as n, normalizeClass as d, renderSlot as a } from "vue";
import { _ as c } from "./_plugin-vue_export-helper-dad06003.js";
const l = {
  name: "CardIcon",
  props: {
    type: {
      type: String,
      default: "neutral"
    }
  }
};
function g(t, s, e, o, u, i) {
  return r(), n("div", {
    class: d(["w-10 h-10 rounded-lg flex items-center justify-center", [
      e.type === "neutral" ? "ct-bg-3 text-gray-500 dark:text-neutral-200" : "",
      e.type === "success" ? "ct-bg-success--2 text-success-600 dark:text-success-200" : "",
      e.type === "warning" ? "ct-bg-warning--2 text-warning-400 dark:text-warning-200" : "",
      e.type === "error" ? "ct-bg-error--2 text-error-600 dark:text-error-200" : "",
      e.type === "modern" ? "ct-fg-2 border broder-gray-200 dark:border-neutral-700" : ""
    ]])
  }, [
    a(t.$slots, "default")
  ], 2);
}
const p = /* @__PURE__ */ c(l, [["render", g]]), x = {
  name: "CardIconSm",
  props: {
    type: {
      type: String,
      default: "neutral"
    }
  }
};
function f(t, s, e, o, u, i) {
  return r(), n("div", {
    class: d(["w-8 h-8 rounded-lg flex items-center justify-center", [
      e.type === "neutral" ? "ct-bg-3 text-gray-500 dark:text-neutral-200" : "",
      e.type === "success" ? "ct-bg-success--2 text-success-600 dark:text-success-200" : "",
      e.type === "warning" ? "ct-bg-warning--2 text-warning-400 dark:text-warning-200" : "",
      e.type === "error" ? "ct-bg-error--2 text-error-600 dark:text-error-200" : "",
      e.type === "modern" ? "ct-fg-2 border broder-gray-200 dark:border-neutral-700" : ""
    ]])
  }, [
    a(t.$slots, "default")
  ], 2);
}
const w = /* @__PURE__ */ c(x, [["render", f]]), y = {}, _ = { class: "inline-flex items-center rounded border border-gray-600 dark:border-gray-200 px-1 py-0.5 font-sans text-xs text-white dark:text-gray-900" };
function b(t, s) {
  return r(), n("kbd", _, [
    a(t.$slots, "default")
  ]);
}
const h = /* @__PURE__ */ c(y, [["render", b]]);
export {
  w as C,
  p as a,
  h as b
};
